import { Action } from '@ngrx/store';

export const FORM_STEPS = [
  { id: 'customer-information', store_id: 'customerInformation', title: 'Customer Information' },
  { id: 'vehicles-information', store_id: 'vehiclesInformation', title: 'Vehicles Information' },
  { id: 'driver-information', store_id: 'driverInformation', title: 'Driver Information' },
  { id: 'motor-carrier-information', store_id: 'motorCarrierInformation', title: 'Motor Carrier Information' },
  { id: 'application-summary', store_id: 'applicationSummary', title: 'Application Summary' },
  { id: 'review-coverage', store_id: 'reviewCoverage', title: 'Review Coverage' },
  { id: 'application-status', store_id: 'applicationStatus', title: 'Application Status' }
];

export const SAVE_FORM = 'SAVE_FORM';
export const SAVE_FORM_STEP = 'SAVE_FORM_STEP';
export const UPDATE_STORE = 'UPDATE_STORE';

export const formReducer = (state = {
  steps: {}, settings: {}
}, action: Action) => {
  let newState;
  switch (action.type) {
    case SAVE_FORM:
      newState = Object.assign({}, state.steps, action.payload);
      return Object.assign({}, state, { steps: newState });

    case SAVE_FORM_STEP:
      let payloadStep = {};

      // if more than one step
      if (Array.isArray(action.payload)) {
        action.payload.forEach(entry => {
          // console.log(entry);
          payloadStep[entry.step] = entry.data;
        });

      // if single step
      } else {
        payloadStep[action.payload.step] = action.payload.data;
      }

      newState = Object.assign({}, state.steps, payloadStep);
      return Object.assign({}, state, { steps: newState });

    case UPDATE_STORE:
      return Object.assign({}, state, action.payload);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/shared/form.reducer.ts